<app-links-select
    [isMultiSelect]="true"
    [links]="(links$ | async)!"
    [selectedLinks]="(selectedLinks$ | async)!"
    [loading]="(isLoading$ | async)!"
    (selectionChange)="onToggleLink($event)"
>
</app-links-select>
